var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatIconTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 29.7998H29.3307",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0131 7.38102C28.3271 5.97803 26.6435 5.41739 25.2717 6.07212L18.9427 8.81575L12.676 7.31923C12.3954 7.25687 12.1148 7.28805 11.8342 7.41276L10.3688 8.12984C9.93233 8.34809 9.65173 8.78458 9.6829 9.25224C9.6829 9.75108 9.9635 10.1564 10.4 10.3746L13.393 11.7465L8.62286 14.1783L4.6633 12.8065C4.28917 12.6818 3.85268 12.713 3.50973 12.8688C3.04206 13.0871 2.69911 13.5548 2.63675 14.0536C2.5744 14.5836 2.76146 15.0825 3.16677 15.4254L7.0328 18.6679C7.37576 18.9485 7.84342 19.042 8.27991 18.8861L15.7625 16.1425L14.3907 20.6009C14.2037 21.1933 14.3907 21.848 14.8584 22.2533C15.139 22.5027 15.5131 22.6275 15.8561 22.6275C16.0743 22.6275 16.3237 22.5651 16.542 22.4716L17.7579 21.8792C18.0697 21.7233 18.3191 21.4739 18.475 21.1621L21.9669 13.8354L27.7036 11.1541C28.3895 10.8111 28.8883 10.2499 29.1378 9.53284C29.3872 8.81575 29.3248 8.06749 29.0131 7.38158V7.38102Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatIconTravel);
export default __webpack_public_path__ + "static/media/gat-icon-travel.05618ab829dab12d4add0eea119afff3.svg";
export { ForwardRef as ReactComponent };